module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Dämmerlicht des Föhrenwalds")]), _vm._v(" "), _c('h4', {
    staticClass: "calibre7 sigil_not_in_toc"
  }, [_vm._v("I")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Dämmerlicht des Föhrenwalds"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nnahm mich auf in seine Tiefen;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nhing der Schnee am müden Zweig,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund die grauen Krähen riefen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Fiel die Flocke matt und stumm"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\naus dem weiten, grauen Raume;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nhin und wieder brach ein Ast"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nschneebeschwert vom Föhrenbaume.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page27",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" Kam ich an ein Totenfeld,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nstanden Kreuze tief im Eise;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nlagen Kränze, längst verwelkt,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nraschelten im Winde leise.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Mußte ob des leisen Sangs,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nden sie miteinander sangen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nmußte, weil ich ihn verstand,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nheimlich an zu weinen fangen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("»Mag ich reden noch so leis,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nmag mich nimmer übertönen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\njener, der da unten ruht:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\neiner von den Musensöhnen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Jener, der dahingetobt"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\neinstens wie mit Sturmesschwingen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nübertönt mich nun nicht mehr,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nmag ich noch so leise singen.«")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Also sprach das Lorbeerblatt."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nHeimwärts wandt' ich meine Schritte;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nhinter mir, vom Wind verweht,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nschwand die Spur auch meiner Tritte.")]), _vm._v(" "), _c('h4', {
    staticClass: "calibre7 sigil_not_in_toc"
  }, [_vm._v("II")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wiederum im Föhrenwald"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nstand ich an der Kirchhofsmauer;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwar ein Grab, und drum gereiht"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nharrten sie in stummer Trauer,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund der Priester im Ornat"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nspendete des Gottes Rat:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n»Tröstet euch!«")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Doch ich stützte in die Hand"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nmir das Haupt, es wollte sinken,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nkonnte aus des Priesters Wort"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nkeinen Trost für mich ertrinken,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nhörte wohl die Botschaft mild,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndoch im Busen tobte wild"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nZweifelsqual.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page28",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" »Jesus, meine Zuversicht«"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsangen sie im ernsten Chore,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund es flatterten im Wind"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nweiße Tücher, schwarze Flore."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWeiße Tücher, schwarzer Flor,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nTränen quollen draus hervor."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nTröstet euch!")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("»Tröstet euch«, so sprach ich leis."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nKönnt' ich, Arme, Trost euch geben!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nFingen sie von neuem an:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n»Christ, mein Heiland, ist im Leben.«"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDoch da überlief's mich heiß,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nweil ich's leider besser weiß."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nSchwacher Trost.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Aber bittrer, tiefer Schmerz"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nmachte meine Lippen beben."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n»Christus lebt, wie sollt' ich nicht"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndarum mich zufrieden geben?«"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nfielen sie von neuem ein,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund so senkte man ihn ein."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nBittrer Hohn.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2b1f9d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0013.vue
// module id = 93
// module chunks = 0